import { formatDate } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
import { BaseService } from "../base/base.service";
import { CountdownConfig } from "ngx-countdown";

@Pipe({ name: "timerValue" })
export class timerValue implements PipeTransform {
  config: CountdownConfig = {
    leftTime: 0,
    format: "",
    prettyText: (text) => {
      return text
        .split(":")
        .map((v) => `<span class="item">${v}</span>`)
        .join("");
    },
  };
  constructor(public service: BaseService) {}
  transform(data: any): any {
    let currentTime = formatDate(new Date(), "hh:mm:ss a ", "en-US", "+0530");
    let currentDuration = moment(currentTime, "HH:mm:ss: A").diff(
      moment().startOf("day"),
      "seconds"
    );
    let start_time = moment(
      data?.channel_content?.start_time,
      "HH:mm:ss: "
    ).diff(moment().startOf("day"), "seconds");
    if (currentDuration >= start_time) {
      let activeDuration = start_time + data?.duration;
      let value = 86400 - currentDuration + start_time;
      this.config.leftTime = value;
      this.secondsToHms();
      if (activeDuration > currentDuration) {
        data["showTimer"] = true;
      }
    } else if (currentDuration < start_time) {
      this.config.leftTime = start_time - currentDuration;
      this.secondsToHms();
    }
    return this.config;
  }

  secondsToHms() {
    let d = this.config.leftTime;
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    if (h) {
      this.config.format = "HH:mm:ss";
    } else {
      this.config.format = "mm:ss";
    }
  }
}
